/**
 * Never edit this file manually. It is generated as part of the building process
 */
export const AppInfo = {
    name: 'medion-alditalk-client',
    appName: 'medion-alditalk-client',
    version: '2.19.4' ,
    defaultLocale: 'de',
    di18nMode: 'TRANSLATE',
    git: {
        shortHash: '3335b1f',
        hash: '3335b1fb84f599c4a35d877c397f514778734686',
        subject: 'Merge branch \'next\' into \'master\'',
        sanitizedSubject: 'Merge-branch-next-into-master',
        authoredOn: '1793794691',
        committedOn: '1793794691',
        branch: 'HEAD',
    }
};

